module.exports = __webpack_public_path__ + "static/img/center-door-wall-steel_256.bcb5fa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center-door-wall-steel_256.png
// module id = MBUj
// module chunks = 0